/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {deleteHeaderOffer, getAllHeaderOffer, searchHeaderOffer} from '../api/header-offer'
import {Link, useParams} from 'react-router-dom'
import {parseDate} from '../../../../utils/dateAndTime'
import {HeaderOfferListModel} from '../interface/HeaderOffer'
import {toast} from 'react-toastify'
import Pagination from '../../../components/Pagination'
import ModalDelete from '../../../components/Modals/ModalDelete'
import Search from '../../../components/Search'
import ModalAddHeaderOffer from '../modal/ModalAddHeaderOffer'
import Spinner from '../../../components/Spinner'
import NoData from '../../../components/common/NoData'

interface IPageParams {
  page: string
}

const ListHeader: FC = () => {
  const [headerList, setHeaderList] = useState<HeaderOfferListModel>()
  const [search, setSearch] = useState<string>('')
  const [deleteId, setDeleteId] = useState<string>('')
  const {page} = useParams<IPageParams>()
  const [loading, setLoading] = useState<boolean>(true)

  function getHeaderOffer() {
    getAllHeaderOffer(page)
      .then((data) => {
        setLoading(false)
        setHeaderList(data)
      })
      .catch((err) => {
        setLoading(false)
        toast.error('Error!')
      })
  }
  useEffect(() => {
    getHeaderOffer()
  }, [page])

  function handleDelete(event: React.ChangeEvent<any>, id: string) {
    event.preventDefault()
    deleteHeaderOffer(id).then((data) => {
      toast.success('Success!')
      getHeaderOffer()
    })
  }
  function handleSearch(event: React.ChangeEvent<any>) {
    event.preventDefault()
    const {value} = event.target
    setSearch(value)
    if (value === '') {
      getHeaderOffer()
      return
    }
    searchHeaderOffer(search).then((data) => {
      setHeaderList(data)
    })
  }

  return (
    <div className='d-flex flex-column flex-column-fluid' id='kt_content'>
      {/*begin::Post*/}
      <div className='post d-flex flex-column-fluid' id='kt_post'>
        {/*begin::Container*/}
        <div id='kt_content_container' className='container-xxl'>
          {/*begin::Card*/}
          <div className='card'>
            {/*begin::Card header*/}
            <div className='card-header border-0 pt-6'>
              {/*begin::Card title*/}
              <div className='card-title'>
                {/*begin::Search*/}
                <Search name={search} placeholder='header' handleSearch={handleSearch} />
                {/*end::Search*/}
              </div>
              {/*begin::Card title*/}
              {/*begin::Card toolbar*/}
              <div className='card-toolbar'>
                {/*begin::Toolbar*/}
                <div className='d-flex justify-content-end' data-kt-header-table-toolbar='base'>
                  <ModalAddHeaderOffer handleGetHeaderOffer={getHeaderOffer} />
                </div>
                {/*end::Toolbar*/}
                {/*begin::Modal - Delete*/}
                <ModalDelete id={deleteId} handleDelete={handleDelete} />
                {/*end::Modal - delete*/}
              </div>
              {/*end::Card toolbar*/}
            </div>
            {/*end::Card header*/}
            {/*begin::Card body*/}
            <div className='card-body pt-0'>
              {/*begin::Table*/}
              <div className='dataTables_wrapper dt-bootstrap4 no-footer'>
                <div className='table-responsive'>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                      {/*begin::Table head*/}
                      <thead>
                        {/*begin::Table row*/}
                        <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                          <th className='min-w-125px' style={{width: '240.65px'}}>
                            HeaderOffer
                          </th>
                          <th className='min-w-125px' tabIndex={0} style={{width: '134.65px'}}>
                            Callback Name
                          </th>
                          <th className='min-w-125px' style={{width: '140.417px'}}>
                            Featured
                          </th>
                          <th className='min-w-125px' style={{width: '140.417px'}}>
                            Created Date
                          </th>
                          <th
                            className='text-end min-w-100px sorting_disabled'
                            style={{width: '106.433px'}}
                          >
                            Actions
                          </th>
                        </tr>
                        {/*end::Table row*/}
                      </thead>
                      {/*end::Table head*/}
                      {/*begin::Table body*/}
                      {headerList && (
                        <tbody className='text-gray-600 fw-bold'>
                          {headerList.data.length === 0 && <NoData />}
                          {headerList.data.length !== 0 &&
                            headerList.data.map((item) => {
                              return (
                                <tr className='odd' key={item._id}>
                                  {/*begin::Header=*/}
                                  <td className='d-flex align-items-center ms-3'>
                                    {/*begin:: Avatar */}
                                    {/* <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                      <Link to={`/header-offer/view/${item._id}`}>
                                        <div className='symbol-label fs-3 bg-light-primary text-primary'>
                                          N
                                        </div>
                                      </Link>
                                    </div> */}
                                    {/*end::Avatar*/}
                                    {/*begin::Header details*/}
                                    <div className='d-flex flex-column'>
                                      <Link
                                        to={`/header-offer/view/${item._id}`}
                                        className='text-gray-800 text-hover-primary mb-1'
                                      >
                                        {item.name}
                                      </Link>
                                      <span>{item.callback_name}</span>
                                    </div>
                                    {/*begin::Header details*/}
                                  </td>
                                  {/*end::Header=*/}
                                  {/*begin::callback name*/}
                                  <td>{item.callback_name}</td>
                                  {/*begin::callback name*/}
                                  {/*begin::featured*/}
                                  <td>
                                    {item.is_featured ? (
                                      <div className='badge badge-light-success fw-bolder'>
                                        Featured
                                      </div>
                                    ) : (
                                      <div className='badge badge-light-danger fw-bolder'>
                                        Not Featured
                                      </div>
                                    )}
                                  </td>
                                  {/*end:: featured*/}
                                  {/*begin::Joined*/}
                                  <td>{parseDate(item.createdAt)}</td>
                                  {/*begin::Joined*/}
                                  {/*begin::Action=*/}
                                  <td className='text-end'>
                                    <Link
                                      to={`/header-offer/edit/${item._id}`}
                                      className='btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4 me-2'
                                    >
                                      Edit
                                    </Link>
                                    <a
                                      href='#'
                                      className='btn btn-danger btn-sm px-4'
                                      data-bs-toggle='modal'
                                      data-bs-target='#kt_modal_delete'
                                      onClick={() => setDeleteId(item._id as string)}
                                    >
                                      Delete
                                    </a>
                                  </td>
                                  {/*end::Action=*/}
                                </tr>
                              )
                            })}
                        </tbody>
                      )}
                      {/*end::Table body*/}
                    </table>
                  )}
                </div>
                <Pagination
                  name='header-offer'
                  currentPage={page}
                  prev_page={headerList?.prev_page}
                  next_page={headerList?.next_page}
                  total_number_of_page={headerList?.total_number_of_page}
                />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Post*/}
    </div>
  )
}

export default ListHeader
